module.exports = "/_next/static/images/WantToRetainCustomers-xs@2x-5bce8a341eb47c4e556a93e47c54111b.png";